import { SQUARE_IMAGE } from '../../../../fields'
import { getImageAssetInitialValues } from '../../helpers'

export const getInitialValues = assets => {
  return {
    [SQUARE_IMAGE]: assets.map(asset => getImageAssetInitialValues(asset))
  }
}
